import React from "react";
import theme from "app/Theme/Theme";
import Svg, { Path } from "react-native-svg";
import normalize from "app/utils/normalize";

const MediaIcon = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["neutral.900"],
  ...props
}) => (
  <Svg
    width={width}
    height={height}
    {...props}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 24 24"
  >
    <Path
      d="M8.818 15.263c-.35 0-.65-.134-.898-.402a1.37 1.37 0 0 1-.375-.966V6.368c0-.376.125-.698.375-.966.249-.268.548-.402.898-.402h2.657c.17 0 .332.034.486.103.153.068.288.165.405.29l.907.975h4.454c.35 0 .65.135.9.403.248.267.373.59.373.966v6.158c0 .376-.125.698-.373.966-.25.268-.55.402-.9.402H8.818Zm0-1.368h8.91V7.737h-4.98l-1.273-1.369H8.818v7.527ZM6.273 18c-.35 0-.65-.134-.899-.402A1.37 1.37 0 0 1 5 16.632V8.42a.69.69 0 0 1 .183-.488.594.594 0 0 1 .453-.196c.18 0 .332.065.454.196a.69.69 0 0 1 .183.488v8.21h10.181c.18 0 .332.066.454.198.122.13.183.293.183.487a.687.687 0 0 1-.183.487.593.593 0 0 1-.454.197H6.274Zm4.454-5.474h5.091c.127 0 .223-.062.287-.188a.319.319 0 0 0-.032-.36L14.56 9.808a.296.296 0 0 0-.254-.137.296.296 0 0 0-.255.137l-1.416 2.035-.78-1.129a.296.296 0 0 0-.254-.137.296.296 0 0 0-.254.137l-.875 1.266a.32.32 0 0 0-.032.36c.063.125.159.187.286.187Z"
      fill={color}
    />
  </Svg>
);

export default MediaIcon;
